import type { JSX } from 'react';

export function SuccessPage(): JSX.Element {
  return (
    <main className="co-container">
      <div className="co-card co-center">
        <div className="co-icon">✓</div>
        <h1>Payment Complete</h1>
        <p className="co-muted">
          Your payment has been processed. You can safely close this window.
        </p>
      </div>
    </main>
  );
}
